// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"088b2174","497":"f0fe7561","578":"5189009d","641":"50cb4384","705":"9b47b443","778":"5d8375fb","884":"e162087a"}[chunkId] + ".chunk.js";
};